export default __webpack_public_path__ + "static/media/wi-dust.89a5d1fb.svg";